import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { statuses, invoiceStatuses, statusClass, statusDisplayLabels, statusSubLabels } from 'payments/translations';
import { orderStatus } from '../../propTypes';
import styles from './index.module.css';

const i18n = (value, paymentType) =>
  paymentType === 'invoices' ? invoiceStatuses[value] : statuses[value];

class Status extends PureComponent {
  render() {
    const {
      value,
      cellProperties: {
        customComponentMetadata: { paymentType },
      },
    } = this.props;
    const statusLabel = statusClass[value];
    const subLabel = statusSubLabels[value];
    const className = classNames(styles.status, styles[statusLabel], {
      [styles.statusTwoLine]: !!subLabel,
    });

    return (
      <div className={className} data-test="status">
        <span>{statusDisplayLabels[value] || i18n(value, paymentType)}</span>
        {subLabel && <span className={styles.statusSubtext}>{subLabel}</span>}
      </div>
    );
  }
}

Status.propTypes = {
  value: orderStatus.isRequired,
  cellProperties: PropTypes.shape({
    customComponentMetadata: PropTypes.shape({ paymentType: PropTypes.string }),
  }).isRequired,
};

export default Status;
